<div class="current-progress" [ngStyle]="{'width': progress + '%'}"></div>
@if (steps.length > 0) {
  @for (step of steps; track step; let i = $index) {
    <div
      class="step"
      [routerLink]="step.urlSlugs"
      [ngStyle]="{'left': step.progress + '%'}"
      [ngClass]="{'step--active': step.active}"
      appClickBlur
      a11yKeyboardClickable
      >
      <vwui-tooltip class="step__tooltip" position="bottom" [label]="step.tooltip">
        <div class="step__text" [attr.data-label]="step.tooltip">{{ (i + 1) }}</div>
        @if (step.blink) {
          <div class="step__blink"></div>
        }
      </vwui-tooltip>
    </div>
  }
}
